import React from 'react';
import PropTypes from 'prop-types';
import { useAlert } from '../ui/Alert';
import MainPage from './MainPage';
import config from '../constants';

const CreatePage = ({ children, show_error = false, headers = {} }) => {
	const { push } = useAlert();

	if (show_error) {
		push({
			error: true,
			message: config.app.error,
		});
	}

	return <MainPage headers={headers}>{children}</MainPage>;
};

CreatePage.propTypes = {
	children: PropTypes.node,
	show_error: PropTypes.bool,
	headers: PropTypes.shape({
		icon: PropTypes.string,
		title: PropTypes.string,
		description: PropTypes.string,
		breadcrumbs: PropTypes.arrayOf(
			PropTypes.shape({
				link: PropTypes.string,
				title: PropTypes.string.isRequired,
			})
		),
	}),
};

CreatePage.defaultProps = {
	show_error: false,
	headers: {},
};

export default CreatePage;
